import type { AvailabilityRecord, User } from '../types';

interface Props {
  members: User[];
  records: AvailabilityRecord[];
  onDark?: boolean;
}

const statusConfig: Record<string, { dot: string; label: string }> = {
  can_drive: { dot: 'bg-green-500', label: 'Can Drive' },
  prefer_not: { dot: 'bg-yellow-400', label: 'Prefer Not' },
  cant_drive: { dot: 'bg-red-500', label: "Can't Drive" },
};

export default function AdminAvailabilitySummary({ members, records, onDark }: Props) {
  if (members.length === 0) return null;

  const recordsByUser = new Map(records.map(r => [r.userId, r]));

  return (
    <div className="mt-2 space-y-1">
      <p className={`text-[10px] font-semibold uppercase tracking-wide ${
        onDark ? 'text-white/50' : 'text-gray-400 dark:text-gray-500'
      }`}>
        Parent Availability
      </p>
      {members.map(member => {
        const record = recordsByUser.get(member.id);
        const config = record ? statusConfig[record.status] : null;

        return (
          <div key={member.id} className="flex items-center gap-2">
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${
              config ? config.dot : onDark ? 'bg-white/30' : 'bg-gray-300 dark:bg-gray-600'
            }`} />
            <span className={`text-xs truncate flex-1 ${
              onDark ? 'text-white/80' : 'text-gray-600 dark:text-gray-400'
            }`}>
              {member.name}
            </span>
            <span className={`text-[10px] flex-shrink-0 ${
              config
                ? (onDark ? 'text-white/60' : 'text-gray-500 dark:text-gray-400')
                : (onDark ? 'text-white/30 italic' : 'text-gray-300 dark:text-gray-600 italic')
            }`}>
              {config ? config.label : 'No response'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
